import axios from 'axios'
import {api_url} from '../../config'

const instance = axios.create({
    baseURL: api_url + '/api'
})

instance.defaults.headers.common['Authorization'] = localStorage.getItem('jwt_token')

export default instance